import React from "react";
import {
  Box,
  Typography,
  Button,
  styled,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import discountIcon from "../../../assets/svg/discount.svg";
import successIcon from "../../../assets/svg/success.svg";
import { motion } from "framer-motion";
import { useCartContext } from "../../../hooks/CartContext";
import { removeCoupon } from "./CouponSideNav";

export const ApplyCoupon = ({
  open,
  handleCouponDrawer,
  dynamicCouponSave,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { applyDiscount, setApplyDiscount } = useCartContext();

  // ✅ Banner only shows if coupon is applied AND discount > 0
  const isCouponActive = applyDiscount?.code != null && +dynamicCouponSave > 0;

  const removeCouponHandler = () =>
    removeCoupon(setApplyDiscount, `Coupon removed !!!`);

  const CouponCard = styled(Box)(({ theme }) => ({
    border: "1px dashed var(--neutral-400)",
    borderRadius: "8px",
    background: "var(--neutral-white)",
    padding: "16px 16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    rowGap: "12px",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  }));

  return (
    <CouponCard className="demo">
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 2,
          flex: 1,
          flexWrap: "wrap",
        }}
      >
        {isCouponActive ? (
          <>
            <img
              src={successIcon}
              alt="Success Icon"
              style={{ height: "32px", width: "auto" }}
            />
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                fontSize: { xs: "13px", sm: "14px" },
                color: "var(--neutral-black)",
              }}
            >
              Saved{" "}
              <Box component="span" sx={{ fontWeight: 700 }}>
                ₹{dynamicCouponSave}
              </Box>{" "}
              using{" "}
              <Box component="span" sx={{ fontWeight: 700 }}>
                {applyDiscount?.code}
              </Box>{" "}
              coupon
            </Typography>
          </>
        ) : (
          <>
            <motion.img
              src={discountIcon}
              alt="Discount Icon"
              animate={{ rotate: [0, 100, 0] }}
              transition={{
                duration: 4,
                ease: "easeInOut",
                repeat: Infinity,
                repeatType: "reverse",
              }}
              style={{ height: "32px", width: "auto" }}
            />
            <Typography
              variant="body2"
              sx={{
                fontWeight: 500,
                fontSize: { xs: "13px", sm: "14px" },
                color: "var(--neutral-black)",
              }}
            >
              Apply coupon
            </Typography>
          </>
        )}
      </Box>
      <Box>
        <Button
          onClick={
            isCouponActive
              ? removeCouponHandler
              : (event) => handleCouponDrawer(true)(event)
          }
          variant="text"
          sx={{
            fontWeight: 600,
            fontSize: { xs: "13px", sm: "14px" },
            color: "var(--primary-red-base)",
            whiteSpace: "nowrap",
          }}
        >
          {isCouponActive ? "Remove" : "Check"}
        </Button>
      </Box>
    </CouponCard>
  );
};
